const RightIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.1875 9H2.8125M2.8125 9L7.875 3.9375M2.8125 9L7.875 14.0625"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default RightIcon;
